exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divStyle{border:1px solid #ced4da;border-radius:5px;justify-content:start;background-color:#e9ecef;min-height:35px;position:relative}.divStyle,.iconStyle{display:flex;align-items:center}.iconStyle{top:10%;right:0;border-radius:50%;background-color:#e6f2fd;border:1px solid #ced4da;width:30px;height:30px;justify-content:center}.MandatoryStyle{background-color:#fde6e6}.selectStyle{font-size:12px;height:38px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fdb6e4a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/Budgeting/Components/TashimBandi.vue
// module id = 660
// module chunks = 0